import { getPathSuffix } from '../utils/url';
export let ENDPOINTS;
(function (ENDPOINTS) {
  ENDPOINTS["SAVE_PREFERENCES"] = "save-preferences";
  ENDPOINTS["LOAD_PREFERENCES"] = "get-preferences";
  ENDPOINTS["SUBMIT_SURVEY"] = "submit-survey";
  ENDPOINTS["UNKNOWN"] = "unknown";
})(ENDPOINTS || (ENDPOINTS = {}));
export const PATH_SUFFIX = {
  SINGLE: 'single',
  PAGE: 'page'
};
export const constructApiEndpoint = endpoint => {
  switch (endpoint) {
    case ENDPOINTS.LOAD_PREFERENCES:
      const pathSuffix = getPathSuffix();
      const loadSuffix = pathSuffix === PATH_SUFFIX.SINGLE ? PATH_SUFFIX.PAGE : pathSuffix;
      return `/hs/cms-preferences-page/load/${loadSuffix}${window.location.search}`;
    case ENDPOINTS.SAVE_PREFERENCES:
      return `${window.location.pathname}${window.location.search}`;
    case ENDPOINTS.SUBMIT_SURVEY:
      return '/hs/cms-subscription-preferences/surveys/submissions';
    default:
      return '';
  }
};